import { Link } from '@lounge-fe/ui-kit'
import { SubNavigationLinkProps } from './types'

export const SubNavigationLink: React.FC<
  React.PropsWithChildren<SubNavigationLinkProps>
> = ({ children, url, variant }) => {
  const textClass =
    variant === 'footer-link' ? 'underline text-[#888888]' : undefined

  return (
    <Link
      as="a"
      className={textClass}
      variant={variant === 'link' ? 'title-six' : 'body-md'}
      href={url}
    >
      {children}
    </Link>
  )
}
